export default ListagemFretesController;

import * as angular from 'angular';
import * as _ from 'lodash';

/** @ngInject */
function ListagemFretesController($state, $scope, $window, Fretes) {

  let vm = this;

  vm.buscarFretes = buscarFretes;
  vm.buscarMaisFretes = buscarMaisFretes;
  vm.abrirDetalhamento = abrirDetalhamento;

  vm.btnVoltar = parseInt(vm.index, 10) > 0;

  vm.infiniteScroll = {
    busy: false,
    finished: false,
    fretes: Fretes.obterCache(vm.index || 0).fretes || []
  };

  $scope.$watch(vm.scrollContainerId, () => {
    var id = vm.scrollContainerId && '#' + vm.scrollContainerId;
    vm.scrollContainer = $window.document.querySelector(id);
  });

  function buscarFretes(offset) {
    let filtroCompleto = {
      cdPessoa: vm.filtro.cd_pessoa,
      nmBase: vm.filtro.nm_base,
      origem: _.pick(vm.filtro.origem, ['id_tipo', 'cd_cidade_uf']),
      destino: _.pick(vm.filtro.destino, ['id_tipo', 'cd_cidade_uf']),
      tipoVeiculo: vm.filtro.tipoVeiculo && vm.filtro.tipoVeiculo.id,
      tipoCarroceria: vm.filtro.tipoCarroceria && vm.filtro.tipoCarroceria.id,
      ordenacao: vm.filtro.ordenacao && vm.filtro.ordenacao.id,
      raio: vm.filtro.raio && vm.filtro.raio.id,
      limit: Fretes.LIMIT,
      offset: offset || 0
    };

    let filtro = _.omit(filtroCompleto, _.isUndefined);

    vm.infiniteScroll.busy = true;

    if (!offset) {
      vm.infiniteScroll.fretes.splice(0);
    }

    return Fretes.buscarFretes(filtro)
      .then(fretes => {
        if (!offset) {
          vm.infiniteScroll.finished = false;
          Fretes.salvarCache(angular.copy(filtro), fretes, vm.index || 0);
          vm.infiniteScroll.fretes = fretes;
        } else {
          for (let frete of fretes) {
            vm.infiniteScroll.fretes.push(frete);
          }
        }

        vm.infiniteScroll.busy = false;
        vm.infiniteScroll.finished = fretes.length !== Fretes.LIMIT;

        return fretes;
      })
      .catch(() => vm.infiniteScroll.finished = !(vm.infiniteScroll.busy = false));
  }

  function buscarMaisFretes() {
    if (vm.infiniteScroll.fretes.length % Fretes.LIMIT === 0) {
      return buscarFretes(vm.infiniteScroll.fretes.length);
    }
  }

  function abrirDetalhamento(frete) {
    $state.go('consulta.fretes.detalhe', _.assign(frete, {index: vm.index || 0}));
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/common/components/listagem-fretes/listagem-fretes.controller.ts
 **/